module.exports = __webpack_public_path__ + "static/media/zaakfield_kimihurura5.a41564d7.jpg";